module.exports = __webpack_public_path__ + "img/liantongAuto.566f8e48.png";